module.exports = __webpack_public_path__ + "img/vmware-logo2.9dcc26ad.png";